
    <b4a-product-supplier-list 
        [suppliers]="suppliers" 
        [clickedNew]="clickedNew.bind(this)"
    ></b4a-product-supplier-list>
  


// WEBPACK FOOTER //
// ./src/app/product/supplier-list-page.container.ts.SupplierListPageComponent.html